import React from "react";
import { data } from "../../Assets/js/data";
import { SRLWrapper } from "simple-react-lightbox";
const Portfolios = () => {
  const portfolios = data.portfolios;
  return (
    <>
      {portfolios.map(portfolio => {
        return (
          <a
            key={`img-${portfolio.title}`}
            href={portfolio.src}
            data-attribute="SRL"
          >
            <img
              className="img-square"
              key={`thumb-${portfolio.title}`}
              alt={portfolio.title}
              src={portfolio.thumbSrc}
            />
          </a>
        );
      })}
    </>
  );
};

const Frontpage = () => {
  const options = {
    showCaption: false
  };
  return (
    <SRLWrapper options={options}>
      <div id="front-page" className="front-page-images">
        <Portfolios />
      </div>
    </SRLWrapper>
  );
};

export default Frontpage;
